import { MONTHS, Month } from "./Month.js";

/**
 * Validates the month number ("01"-"12").
 */
export function validateMonth(month: string): Month {
  const cast = month as Month;
  if (MONTHS.includes(cast)) {
    return cast;
  } else {
    throw new Error(`Invalid month: ${month}.`);
  }
}
